import React from 'react';
import { ShieldCheck, Zap, Lock, CreditCard } from 'lucide-react';
export function BuySection() {
  return <section id="comprar" className="py-16 px-4 bg-brand-base relative" data-id="element-39">
      <div className="max-w-xl mx-auto bg-brand-light rounded-2xl p-6 md:p-10 border-2 border-accent-base shadow-[0_0_40px_rgba(232,93,44,0.15)] text-center relative overflow-hidden" data-id="element-40">
        <h2 className="text-2xl md:text-3xl font-oswald font-bold text-white uppercase mb-2" data-id="element-41">
          Empezá tu transformación hoy
        </h2>
        <p className="text-gray-300 mb-6" data-id="element-42">
          Acceso inmediato a los 3 tomos + 3 bonos exclusivos.
        </p>

        {/* Extra gift — calculadora */}
        <div className="bg-brand-dark border border-accent-base rounded-xl overflow-hidden mb-6 text-left relative shadow-[0_0_25px_rgba(232,93,44,0.2)]" data-id="element-43">
          <div className="absolute top-2 right-2 bg-accent-base text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1 rounded-full z-10 animate-pulse" data-id="element-44">
            Regalo extra
          </div>
          <div className="relative h-36 overflow-hidden" data-id="element-45">
            <img src="https://cdn.magicpatterns.com/uploads/1ero2SbKuEf6wdWvofqF5K/Captura_de_pantalla_2026-05-22_115922.png" alt="Calculadora de proteínas e hidratación" className="w-full h-full object-cover object-top" data-id="element-46" />
            <div className="absolute inset-0 bg-gradient-to-b from-transparent via-brand-dark/40 to-brand-dark pointer-events-none" data-id="element-47"></div>
          </div>
          <div className="p-4 -mt-4 relative z-10" data-id="element-48">
            <p className="text-white font-oswald text-base md:text-lg uppercase leading-tight tracking-wide" data-id="element-49">
              Comprando <span className="text-accent-base" data-id="element-50">HOY</span> ¡llevate
              una calculadora de proteínas e hidratación!
            </p>
          </div>
        </div>

        <div className="mb-8" data-id="element-51">
          <p className="text-gray-400 text-lg line-through mb-1" data-id="element-52">
            Precio normal: $52.690
          </p>
          <div className="flex justify-center items-start gap-1" data-id="element-53">
            <span className="text-accent-base text-2xl font-bold mt-2" data-id="element-54">$</span>
            <span className="text-white text-6xl font-oswald font-bold tracking-tight" data-id="element-55">
              19.990
            </span>
            <span className="text-gray-400 text-sm mt-8 ml-1" data-id="element-56">ARS</span>
          </div>
        </div>

        <a href="https://checkout.ebookpoint.shop/cart/59526388777041:1" className="block w-full bg-accent-base hover:bg-accent-dark text-white font-oswald text-2xl py-5 px-8 rounded-xl shadow-[0_10px_20px_rgba(232,93,44,0.3)] transition-all transform hover:-translate-y-1 hover:shadow-[0_15px_30px_rgba(232,93,44,0.4)] active:translate-y-0 uppercase tracking-wide mb-6" data-id="element-57">
          QUIERO CAMBIAR MI JUEGO
        </a>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-center" data-id="element-58">
          <div className="flex flex-col items-center gap-2" data-id="element-59">
            <Lock className="w-6 h-6 text-gray-400" data-id="element-60" />
            <span className="text-xs text-gray-400" data-id="element-61">Pago 100% Seguro</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-62">
            <Zap className="w-6 h-6 text-gray-400" data-id="element-63" />
            <span className="text-xs text-gray-400" data-id="element-64">Acceso Inmediato</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-65">
            <ShieldCheck className="w-6 h-6 text-gray-400" data-id="element-66" />
            <span className="text-xs text-gray-400" data-id="element-67">Garantía 7 días</span>
          </div>
          <div className="flex flex-col items-center gap-2" data-id="element-68">
            <CreditCard className="w-6 h-6 text-gray-400" data-id="element-69" />
            <span className="text-xs text-gray-400" data-id="element-70">Todos los medios</span>
          </div>
        </div>
      </div>
    </section>;
}